import { Card, CardBody } from 'react-bootstrap'
import { Intervento } from '../../types'
import dayjs from 'dayjs'
import classNames from 'classnames'
import { getLabelCampoStorico, getLabelStatoIntervento } from '../../utils/utils'
import { orderBy } from 'lodash'

export default function CardStoricoIntervento({
  intervento,
}: {
  intervento: Intervento | undefined
}) {
  return (
    <Card className="mt-3 mb-5">
      <CardBody>
        <div className="py-1 border-bottom">
          <div className="d-flex justify-content-between">
            <h4 className="heading-h4 d-flex align-items-center">
              <span className="material-icons text-secondary me-2">
                history
              </span>
              Storico
            </h4>
          </div>
        </div>
        <div className="mt-3">
          {orderBy(intervento?.logs, ['data_ora'], ['desc'])?.map((storia) => (
            <div key={storia.id} className="mt-3 border-bottom pb-3">
              <div className="p-sm">
                {dayjs(storia.data_ora).format('DD.MM.YYYY')} -{' '}
                {dayjs(storia.data_ora).format('HH:mm')}
              </div>
              <div className="mt-2">
                <span className="p-md me-1 text-black">
                  {storia.user_fullname}
                </span>
                <span className="p-md text-body-secondary me-1">
                  ha impostato
                </span>
                <span className="p-md me-1">{getLabelCampoStorico(storia.campo)}</span>
                <span className="p-md text-body-secondary me-1">a</span>
                <span className="p-md">{storia.valore}</span>
              </div>
              <div>
                <span className="p-md text-body-secondary me-1">
                  Stato intervento:
                </span>
                <span
                  className={classNames('badge', {
                    'badge-state-success':
                      storia.stato === 'trasmesso' ||
                      (storia.stato === 'eseguito' &&
                        intervento?.tipo_intervento ===
                          'rapporto_taratura'),
                    'badge-state-all': storia.stato !== 'trasmesso',
                  })}
                >
                  {getLabelStatoIntervento(storia.stato)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  )
}
